import { Component, inject } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  template: ``
})
export class LogoutComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    this.logout();
  }

  private logout(): void {
    try {
      this.authService.logout();
    } catch (error) {
      console.error('Logout failed:', error);
      this.router.navigate(['/login'], { queryParams: { error: 'Logout failed. Please try again.' } });
    }
  }
}
